
export enum ContractType {
  EuroMyronToken = "EuroMyronToken",
  AssetFinPool = "AssetFinancingPool",
  InventoryFinPool= "InventoryFinancingPool",
  ReceivableFinPool= "ReceivableFinancingPool",
  ProofOfAsset = "ProofOfAsset"
}

export enum AssetType {
  Inventory = "INVENTORY",
  Receivable = "RECEIVABLE"
}

export enum EndpointType {
  Coredinate = "Coredinate",
  Pop = "POP",
  Plentymarkets = "Plentymarkets",
}

export enum PoolStatus {
  Onboarding = "ONBOARDING",
  Open = "OPEN",
  Active = "ACTIVE",
  Closed = "CLOSED",
}

export enum EURMOperation {
  DEPOSIT = "DEPOSIT",
  WITHDRAW = "WITHDRAW"
}

export enum PaymentType {
  INTEREST = "INTEREST",
  IFP = "IFP"
}

export enum EditUserType {
  ManageUsers = "ManageUsers",
  Settings = "Settings"
}

export enum TxResult {
  SUCCESS = "success",
  ERROR = "error",
  PROCESSING = "processing"
}

export enum SetPasswordType {
  ResetPassword = "reset",
  ActivateAccount = "activate"
}

export enum SetPasswordResult {
  None = "none",
  Successful = "successful",
  Failed = "failed",
  Invalid = "invalid"
}

export enum TransactionsPageModals {
  NoModal = "noModal",
  TransactionDetails = "transactionDetails",
  FailOperation = "failOperation",
}

export enum TransactionsModals {
  NoModal = "noModal",
  AddTransaction = "addTransaction",
  WithdrawalSummary = "withdrawalSummary",
  TransactionResult = "transactionResult",
  Loading = "loading"
}

export enum WithdrawalCardModals {
  NoModal = "noModal",
  MakeWithdrawal = "makeWithdrawal",
  WithdrawalSummary = "withdrawalSummary",
  WithdrawalResult = "withdrawalResult",
  Loading = "loading"
}

export enum InvestmentTransactionModals {
  NoModal = "noModal",
  MakeInvestment = "makeInvestment",
  InvestmentTransactionSummary = "investmentTransactionSummary",
  InvestmentTransactionResult = "investmentTransactionResult",
  Loading = "loading"
}

export enum CustomerPageModals {
  NoModal = "noModal",
  CustomerDetails = "customerDetails",
}

export enum MerchantsPageModals {
  NoModal = "noModal",
  CreateMerchant = "createMerchant",
  AfpDetails = "afpDetails",
}

export enum UsersPageModals {
  NoModal = "noModal",
  CreateUser = "createUser",
  UserDetails = "userDetails",
}

export enum AssetsPageModals {
  NoModal = "noModal",
  Details = "details",
}

export enum PaymentModals {
  NoModal = "noModal",
  PaymentSummary = "paymentSummary",
  PaymentResult = "paymentResult",
  Loading = "loading"
}

export enum SharedModals {
  NoModal = "noModal",
}

export enum WalletSetupStep {
  Welcome = "welcome",
  Loading = "loading",
  Save = "save",
  Error = "error",
}

export enum WithdrawalType {
  Interest = "INTEREST",
  Investment = "INVESTMENT"
}
